"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeDevConfigFormStorage = exports.mergeFormStorage = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * 浅合并对象，把从localStorage中查询到的数据 合并到 targetObj 中， 只合并 targetObj 已有的属性。
 * @param targetObj
 * @param storageKey localStorage key
 * @param options {
 *   keyMap 是当target中的key和source中的不一样时做的匹配映射，比如target中key为A,source中key为B。 记作 A:B
 *   keyMap: {
 *     A:B
 *   }
 * }
 */
var mergeFormStorage = function mergeFormStorage(targetObj, storageKey, options) {
  if (!targetObj || _typeof(targetObj) !== 'object') {
    console.warn("targetObj must Object ant not Null. targetObj is ".concat(targetObj));
    return targetObj;
  }

  if (!storageKey) {
    console.warn("storageKey is falsy ,".concat(storageKey));
    return targetObj;
  }

  var _ref = options || {},
      _ref$keyMap = _ref.keyMap,
      keyMap = _ref$keyMap === void 0 ? {} : _ref$keyMap;

  try {
    var customConfigStr = localStorage.getItem(storageKey);

    if (customConfigStr) {
      var customConfig = JSON.parse(customConfigStr);

      if (_typeof(customConfig) === 'object') {
        var newConfig = _objectSpread({}, targetObj); // 执行merge ,只merge第一层


        Object.keys(newConfig).forEach(function (key) {
          var sourceKey = keyMap[key] || key;

          if (customConfig[sourceKey]) {
            newConfig[key] = customConfig[sourceKey];
          }
        });
        return newConfig;
      }
    }
  } catch (e) {
    console.warn('mergeFormStorage', e);
  }

  return targetObj;
};
/**
 * @see mergeFormStorage
 */


exports.mergeFormStorage = mergeFormStorage;

var mergeDevConfigFormStorage = function mergeDevConfigFormStorage(targetObj, options) {
  var _ref2 = options || {},
      _ref2$storageKey = _ref2.storageKey,
      storageKey = _ref2$storageKey === void 0 ? 'dbg_env_config' : _ref2$storageKey;

  return mergeFormStorage(targetObj, storageKey, options);
};

exports.mergeDevConfigFormStorage = mergeDevConfigFormStorage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/toolkit/lib/storage/index.js
// module id = 431
// module chunks = 3